import { Image } from 'entities/Photo/interfaces';
import {
  CLEAR_REPORT_PHOTO,
  GET_REPORT_TRIP_ERROR,
  GET_REPORT_TRIP_REQUEST,
  GET_REPORT_TRIP_SUCCESS,
} from './constants';

export const getRepTripRequest = (id: string) => ({
  type: GET_REPORT_TRIP_REQUEST,
  payload: id,
});

export const getRepTripSuccess = (pictures: Array<Image>) => ({
  type: GET_REPORT_TRIP_SUCCESS,
  payload: pictures,
});

export const getRepTripError = (error: Error | null) => ({
  type: GET_REPORT_TRIP_ERROR,
  payload: error,
});

export const clearReportPhoto = () => ({
  type: CLEAR_REPORT_PHOTO,
});

export type Actions =
  | ReturnType<typeof getRepTripError>
  | ReturnType<typeof getRepTripSuccess>
  | ReturnType<typeof getRepTripRequest>
  | ReturnType<typeof clearReportPhoto>;
